import { Injectable } from '@angular/core';
import { LoadUser, User } from '@macs-frontend/web-macs/shared';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getCurrentUser, MetaState } from '../../reducers/meta';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  user$: Observable<User>;
  canLoadUser = true;

  loadUser(reload: boolean = false) {
    if (this.canLoadUser || reload) {
      this.store$.dispatch(new LoadUser());
    }
    this.canLoadUser = false;
  }

  preventLoadingUser() {
    this.canLoadUser = false;
  }

  constructor(readonly store$: Store<MetaState>) {
    this.user$ = store$.select(getCurrentUser);
  }
}
